import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Table } from "react-bootstrap";
import AxiosInstance from "../../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../../Services/BugService";
// import "./BugDetailsPage.css";
import { useAuth } from "../../../ProtectedRoute/AppContext";
import { useNavigate } from "react-router-dom";
import { imageListClasses } from "@mui/material";
import Loader from "../../../DesignLayout/Loader/Loader";
function BugDetails() {
  const [userIds, setUserIds] = useState("");
  const navigate = useNavigate();
  const { user } = useAuth();
  const [bugs, setBugs] = useState([]);
  const [status, setStatus] = useState([]);
  const [priority, setPriority] = useState([]);
  const [users, setUsers] = useState([]);
  const [tasks, setTasks] = useState([]);
  const location = useLocation();
  const [Loading,setLoading]=useState(false);
  const [image, setImage] = useState(null);
  const [bugsimage, setbugsImage] = useState([]);
  const [BugHistory, sethistory] = useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [shownote, setShownote] = useState([]);
  const [preview, setPreview] = useState(null);
  const { bugId } = location.state || {};
  const [noteInput, setNoteInput] = useState(""); // Temporary note input
  const [fileInput, setFileInput] = useState(null); // Temporary file input
  const date = new Date();
  const formatDateForInput = (date) => {
    const tzOffset = new Date(date).getTimezoneOffset() * 60000; // Adjust for timezone offset
    const localISOTime = new Date(date - tzOffset).toISOString();
    return localISOTime.slice(0, 16); // Remove milliseconds and 'Z'
  };

  //const dueDate=formatDateForInput(bugs[0].dueDate);
  const [newBug, setNewBug] = useState({
    bugId: bugId,
    bugName: "",
    
    assignedTo: "0",
    dueDate: formatDateForInput(date), // Format for "datetime-local"
    status: "",
    priority: "",
    bugDescription: "",
    modifiedBy: user.userId,
    note: "",
    filepath: "",
  });

  useEffect(() => {
    const fetchBugData = async () => {
      try {
        const bugResponse = await AxiosInstance.get(
          `${API_ENDPOINTS.GET_BUG_ONLOAD}?bugId=${bugId}`
        );
        console.log("Fetched data:", bugResponse.data);
        const bugData = bugResponse.data.bugs || [];
        
        setBugs(bugData);
        setStatus(bugResponse.data.status || []);
        setPriority(bugResponse.data.priority || []);
        setUsers(bugResponse.data.users || []);
        setTasks(bugResponse.data.tasks || []);
        sethistory(bugResponse.data.history || []);
  
        // Ensure bugData[0].image is valid before setting it
        if (bugData[0]?.image) {
          setShownote(bugData[0].image);
          console.log("Shownote set to:", bugData[0].image);
        }
      } catch (error) {
        console.error("Error fetching bug data:", error);
      }
    };
  
    fetchBugData();
  }, [bugId]); // Add dependencies if necessary
  
  // Separate useEffect to process shownote
  useEffect(() => {
    if (Array.isArray(shownote) && shownote.length > 0) {
      shownote.forEach((data) => {
        const filePath = data.FilePath; // Use `data` directly, not `data[index]`
        
        if (filePath) {
          const baseUrl = AxiosInstance.defaults.baseURL; // Your server base URL
          const imageUrl = filePath.startsWith("/")
            ? `${baseUrl}${filePath}`
            : `${baseUrl}/${filePath}`;
          console.log("Image URL:", imageUrl); // Log to verify
          setShownote((prev) => [...prev, imageUrl]); // Store image URLs in an array
        }
      });
    }
  }, [shownote]); // Dependency on shownote
  

  const getStatusName = (statusId) => {
    const statusObj = status.find((item) => item.id === statusId);
    return statusObj ? statusObj.name : "Unknown"; // Fallback to "Unknown"
  };

  const getPriorityName = (priorityId) => {
    const priorityObj = priority.find((item) => item.id === priorityId);
    return priorityObj ? priorityObj.name : "Unknown";
  };

  const getAssignedToName = (userId) => {
    const userObj = users.find((item) => item.userId === parseInt(userId));
    return userObj ? userObj.userName : "Unassigned";
  };

  useEffect(() => {
    if (bugs.length > 0 && bugs[0]?.assignedTo) {
      setNewBug((prev) => ({
        ...prev,
        bugName: bugs[0].bugName,
        assignedTo: bugs[0].assignedTo,
        status: bugs[0].status,
        priority: bugs[0].priority,
      }));
    }
  }, [bugs]);

  const baseUrl =
    "https://localhost:7142/Images/068a2a13-4630-4caf-92d2-e16f52aaa431.png";

  // Get status color
  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
      case "1":
        return "#ffc107";
      case "InProgress":
      case "2":
        return "#198754";
      case "OnHold":
      case "3":
        return "#17a2b8";
      case "Completed":
      case "4":
        return "#28a745";
      case "ToBeTested":
      case "6":
        return "#0d6efd";
      default:
        return "#dc3545";
    }
  };
  // Handle adding a note
  const handleAddNote = () => {
    if (!noteInput.trim()) {
      toast.error("Note cannot be empty");
      return;
    }

    const newNote = { text: noteInput, file: fileInput };
    setNewBug((prev) => ({
      ...prev,
      note: [...prev.Note, newNote], // Use note (singular)
    }));

    // Reset input fields
    setNoteInput("");
    setFileInput(null);
    setPreview(null);
  };
  // Handle file input
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileInput(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Convert file to Base64
  const fileToBase64 = (input) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);

      if (input instanceof File || input instanceof Blob) {
        reader.readAsDataURL(input);
      } else {
        reject(
          new Error("Unsupported input type. Only File or Blob is allowed.")
        );
      }
    });
  };
  // Handle Paste (for screenshot or copied images)
  const handlePaste = async (e) => {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const blob = items[i].getAsFile();
        if (blob) {
          try {
            const base64Image = await fileToBase64(blob);
            setImage(base64Image);
            setNewBug((prev) => ({
              ...prev,
              filePath: base64Image,
            }));
          } catch (error) {
            console.error("Error processing pasted image:", error);
            toast.error("Failed to process the pasted image.");
          }
        }
      }
    }
  };
  const handlefile = (e) => {
    const file = e.target.files[0];
    if (file) {
      //setImage(file);

      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  
const [showupdateBug, setupdateBug] = useState(false); // Track which section to show

  // Update this in the onClick event of the "Create Bug" button
  const handleupdateBugClick = () => {
    setupdateBug(true); // Show bug section
  };
  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
      case "1":
        return "#d32121";
      case "Medium":
      case "2":
        return "#d4f004";
      case "Low":
      case "3":
        return "#04f0d1";
      case "Critical":
      case "4":
        return "#f00404";
      default:
        return "#dc3545";
    }
  };

  const updateBug = async (e) => {
    e.preventDefault();
    
    if (!bugs || bugs.length === 0) {
      toast.error("Bug details are not loaded.");
      return;
    }
    const defaultBug = bugs[0];
    
    
    const userIds=users.filter((x)=>x.userName===bugs[0]?.assignedTo).map((d)=>d.userId).toString();
       
    const priorityData = priority.filter((y) => y.name === defaultBug.priority);
    const statusData = status.filter((z) => z.name === defaultBug.status);

    const mergedBug = {
      ...newBug,
      bugName: newBug.bugName || defaultBug.bugName,
      status: newBug.status || statusData,
      priority: newBug.priority || priorityData,
      dueDate: newBug.dueDate || defaultBug.dueDate,
      assignedTo: newBug.assignedTo || userIds,
      bugDescription: newBug.bugDescription || defaultBug.bugDescription,
    };
    setLoading(true);
    try {
      const response = await AxiosInstance.put(API_ENDPOINTS.Update_Bug, mergedBug);
    
      if (response.data) {
        localStorage.setItem("bugdMessage",response.data.message || "Bug updated successfully.");
    //navigate("/bugs");
    window.location.reload()
      } else {
        toast.error("Failed to update the bug.");
      }
    } catch (error) {
      toast.error(error.response?.data?.title || "Failed to update. Check your inputs.");
    }
    finally{
      setLoading(false);
    }
  }    

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewBug((prev) => ({
      ...prev,
      [name]: value || prev[name],
    }));
  };
  window.onload = () => {
    const message = localStorage.getItem("bugdMessage");
    if (message) {
        toast.success(message);
        localStorage.removeItem("bugdMessage"); // Clear after showing
    }
  };
  return (
    <div>
      <ToastContainer />
      <Loader loading={Loading} />
      <div className="border border-1">
        <div className="d-flex bg-info text-white p-2 align-items-center justify-content-between-center">
          <div className="col-md-6">
            <h5>Bug Details</h5>
          </div>

          {/* <div className="col-md-6 text-end">
          {(user.role===1 || user.role===2)&&(
 <button className="btn btn-primary">Create Bug</button>
          )}
        </div> */}
        </div>
        {( !showupdateBug) && (
        <form  enctype="multipart/form-data">
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>BugId</th>
                <th>Bug Name</th>
                <th>Task Name</th>
                <th>Created By</th>
                <th>Status</th>
                <th>Due Date</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              {bugs.map((bug) => (
                <React.Fragment key={bug.bugId}>
                  <tr>
                    <td>BG-{bug.bugId}</td>
                    <td>
                      {bug.bugName} 
                    </td>

                    <td>{bug.projectTaskId}</td>
                    <td className="text-center">{bug.createdBy}</td>

                    <td
                      style={{
                        backgroundColor: getStatusColor(
                          newBug.status || bug.status
                        ),
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                     
                   {getStatusName(bug.status) }
                      
                    </td>

                    <td>
                      {user.role === 1 ? (
                        <input
                          type="date"
                          name="dueDate" className="form-control"
                          value={
                            new Date(bug.dueDate).toISOString().split("T")[0] ||
                            new Date(newBug.dueDate)
                              .toISOString()
                              .split("T")[0] ||
                            ""
                          } // Use newBug first, fallback to default bug
                          onChange={(e) =>
                            setNewBug((prev) => ({
                              ...prev,
                              dueDate: e.target.value,
                            }))
                          }
                          placeholder={
                            new Date(bug.dueDate).toISOString().split("T")[0]
                          }
                        />
                      ) : (
                        <div>
                          {new Date(bug.dueDate).toISOString().split("T")[0]}
                        </div>
                      )}
                    </td>

                    <td
                      style={{
                        backgroundColor: getPriorityColor(
                          newBug.priority || bug.priority
                        ),
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                    
                         
                         {getPriorityName(bug.priority) }
                             
                         
                    </td>
                  </tr>
                  <tr className="p-5">
                    <td className="p-2"></td>
                  </tr>
                  <tr>
                    <th className="thead table-primary">Assigned To</th>
                    <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                    >
                      {getAssignedToName(bug.assignedTo)}
                         
                         
                    </td>
                    <th className="table-primary">Started Date</th>
                    <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                      colSpan="2"
                    >
                      {new Date(bug.createdDate).toISOString().split("T")[0]}
                    </td>
                    {user.role === 1 && (
                      <>
                        <th className="table-primary">Reported Date</th>
                        <td
  className="tdata"
  style={{ backgroundColor: "#ebecedd7" }}
  colSpan="2"
>
  {new Date(bug.reportingDate).toLocaleString("en-GB", {
    weekday: "short", // "Thu"
    day: "2-digit", // "23"
    month: "short", // "Jan"
    year: "numeric", // "2025"
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Use 24-hour format
  })}
</td>
                      </>
                    )}
                  </tr>
                  <tr className="p-5">
                    <td className="p-2"></td>
                  </tr>
                  <tr className="mt-5" style={{ height: "60px" }}>
                    <th className="table-primary align-items-center">
                      Description
                    </th>
                    <td>
                     
                    
                      
                        {bug.bugDescription}
                       
                    </td>
                    {user.role === 1 && (
                      <>
                        <th className="table-primary">Expected Date</th>
                        <td
                          className="tdata"
                          style={{ backgroundColor: "#ebecedd7" }}
                        >
                          {
                            new Date(bug.expectedDate)
                              .toISOString()
                              .split("T")[0]
                          }
                        </td>
                      </>
                    )}
                  </tr>
                  {shownote.map((img, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td colSpan="7">
                          <label htmlFor={`Note-${index}`} className="fs-5">
                            Note
                          </label>
                          <textarea type="text"
                            name={`Note-${index}`}
                            id={`Note-${index}`}
                            className="w-100 p-2 form-control"
                            defaultValue={img.note}
                            onChange={(e) =>
                              setNewBug((prev) => ({
                                ...prev,
                                Note: e.target.value,
                              }))
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="7">
                          <div className="attach-file-container">
                            <div>
                              {bugsimage ? (
                                <>
                                  <img
                                    src={`${AxiosInstance.defaults.baseURL}${img.filepath}`}
                                    alt="attached"
                                    style={{
                                      maxWidth: "300px",
                                      maxHeight: "300px",
                                      cursor: "pointer", // Add pointer cursor to indicate clickability
                                    }}
                                    onClick={() => setShowModal(true)} // Trigger modal on click
                                  />
                                  {showModal && (
                                    <div
                                      className="modal-overlay"
                                      onClick={() => setShowModal(false)} // Close modal on overlay click
                                      style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <div
                                        className="modal-content"
                                        onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking on the image
                                        style={{
                                          position: "relative",
                                          background: "#fff",
                                          padding: "10px",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <img
                                          src={`${AxiosInstance.defaults.baseURL}${img.filepath}`}
                                          alt="Full size"
                                          style={{
                                            maxWidth: "90vw",
                                            maxHeight: "90vh",
                                          }}
                                        />
                                        <button
                                          onClick={() => setShowModal(false)}
                                          style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            background: "red",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          ✕
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div>
                                  <span>No image found</span>
                                  <div
                                    className="upload-area"
                                    style={{
                                      border: "2px dashed #ccc",
                                      padding: "20px",
                                      width: "100%",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                    onPaste={handlePaste}
                                  >
                                    <h4>Attach Screenshot or File</h4>

                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={handlefile}
                                      id="file-input"
                                    />
                                  </div>
                                </div>
                              )}
                              {/* <img src={bug.filePath}/> */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}

                  
                  {/* Add Note Section */}
                  {/* <tr>
                    <td colSpan="7">
                      <label htmlFor="note" className="fs-5">
                        Add Note
                      </label>
                      <input
                        type="text"
                        name="note"
                        id="note"
                        className="w-100 p-2"
                        value={noteInput}
                        onChange={(e) => setNoteInput(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">
                      <div
                        className="upload-area"
                        style={{
                          border: "2px dashed #ccc",
                          padding: "20px",
                          textAlign: "center",
                        }}
                      >
                        <h4>Attach Screenshot or File</h4>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                        {preview && (
                          <img
                            src={preview}
                            alt="Preview"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "300px",
                              marginTop: "10px",
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">
                      <button
                        type="button"
                        // onClick={handleAddNote}
                        className="btn btn-success"
                      >
                        Add Note
                      </button>
                    </td>
                  </tr> */}
                  <tr>
                    <td colSpan="7">
                  
 <button className="btn btn-warning w-100" onClick={handleupdateBugClick}>
 Update Bug
</button>
                   
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
          
        </form>
        )} 
        {( showupdateBug) && (
        <form onSubmit={updateBug} enctype="multipart/form-data">
          <Table striped bordered hover responsive className="shadow-sm mt-3">
            <thead className="table-primary">
              <tr>
                <th>BugId</th>
                <th>Bug Name</th>
                <th>Task Name</th>
                <th>Created By</th>
                <th>Status</th>
                <th>Due Date</th>
                <th>Priority</th>
              </tr>
            </thead>
            <tbody>
              {bugs.map((bug) => (
                <React.Fragment key={bug.bugId}>
                  <tr>
                    <td>BG-{bug.bugId}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name="bugName"
                        defaultValue={bug.bugName} // Show newBug.bugName first, fall back to bugs[0]?.bugName, or empty string
                        onChange={(e) => {
                          setNewBug((prev) => ({
                            ...prev,
                            bugName: e.target.value, // Update newBug.bugName
                          }));
                        }}
                        // className="w-100 p-1 border border-white bg-light rounded-2"
                      />
                    </td>

                    <td>{bug.projectTaskId}</td>
                    <td className="text-center">{bug.createdBy}</td>

                    <td
                      style={{
                        backgroundColor: getStatusColor(
                          newBug.status || bug.status
                        ),
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      <select
                        name="status" className="form-select"
                        value={newBug.status || bug.status} // Use newBug first, fallback to bug
                        onChange={(e) =>
                          setNewBug((prev) => ({
                            ...prev,
                           status: e.target.value,
                          }))
                        }
                      >
                        {status.map((statusOption) => (
                          <option value={statusOption.id} key={statusOption.id}>
                            {statusOption.name}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td>
                     
                        <input
                          type="date"
                          name="dueDate" className="form-control"
                          value={
                            new Date(bug.dueDate).toISOString().split("T")[0] ||
                            new Date(newBug.dueDate)
                              .toISOString()
                              .split("T")[0] ||
                            ""
                          } // Use newBug first, fallback to default bug
                          onChange={(e) =>
                            setNewBug((prev) => ({
                              ...prev,
                              dueDate: e.target.value,
                            }))
                          }
                          placeholder={
                            new Date(bug.dueDate).toISOString().split("T")[0]
                          }
                        />
                      
                    </td>

                    <td
                      style={{
                        backgroundColor: getPriorityColor(
                          newBug.priority || bug.priority
                        ),
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      
                        <select
                          name="priority" className="form-select"
                          value={newBug.Priority || bug.priority} // Use newBug first, fallback to bug
                          onChange={(e) =>
                            setNewBug((prev) => ({
                              ...prev,
                              priority: e.target.value,
                            }))
                          }
                        >
                          {priority.map((priorityData) => (
                            <option
                              value={priorityData.id}
                              key={priorityData.id}
                            >
                              {priorityData.name}
                            </option>
                          ))}
                        </select>
                     
                    </td>
                  </tr>
                  <tr className="p-5">
                    <td className="p-2"></td>
                  </tr>
                  <tr>
                    <th className="thead table-primary">Assigned To</th>
                    <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                    >
                     
                      
                        <select
                          name="assignedTo"
                          id="assignedTo" className="form-select"
                          value={newBug.assignedTo || bugs[0]?.assignedTo}
                          onChange={(e) =>
                            setNewBug((prev) => ({
                              ...prev,
                              assignedTo: e.target.value,
                            }))
                          }
                        >
                          {users.map((data) => (
                            <option key={data.userId} value={data.userId}>
                              {data.userName}
                            </option>
                          ))}
                        </select>
                      
                    </td>
                    <th className="table-primary">Started Date</th>
                    <td
                      className="tdata"
                      style={{ backgroundColor: "#ebecedd7" }}
                      colSpan="2"
                    >
                      {new Date(bug.createdDate).toISOString().split("T")[0]}
                    </td>
                   
                      <>
                        <th className="table-primary">Reported Date</th>
                        <td
  className="tdata"
  style={{ backgroundColor: "#ebecedd7" }}
  colSpan="2"
>
  {new Date(bug.reportingDate).toLocaleString("en-GB", {
    weekday: "short", // "Thu"
    day: "2-digit", // "23"
    month: "short", // "Jan"
    year: "numeric", // "2025"
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Use 24-hour format
  })}
</td>
                      </>
                  
                  </tr>
                  <tr className="p-5">
                    <td className="p-2"></td>
                  </tr>
                  <tr className="mt-5" style={{ height: "60px" }}>
                    <th className="table-primary align-items-center">
                      Description
                    </th>
                    <td
                      style={{ backgroundColor: "#ebecedd7" }}
                      className=""
                      colSpan={user.role === 1 ? 4 : 8}
                    >
                      <input
                        type="text"
                        name="bugDescription"
                        id="bugDescription"
                        className="text-start form-control"
                        defaultValue={bug.bugDescription}
                        onChange={(e) =>
                          setNewBug((prev) => ({
                            ...prev,
                            bugDescription: e.target.value,
                          }))}
                      />
                    </td>
                    {user.role === 1 && (
                      <>
                        <th className="table-primary">Expected Date</th>
                        <td
                          className="tdata"
                          style={{ backgroundColor: "#ebecedd7" }}
                        >
                          {
                            new Date(bug.expectedDate)
                              .toISOString()
                              .split("T")[0]
                          }
                        </td>
                      </>
                    )}
                  </tr>
                  {shownote.map((img, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td colSpan="7">
                          <label htmlFor={`Note-${index}`} className="fs-5">
                            Note
                          </label>
                          <textarea type="text"
                            name={`Note-${index}`}
                            id={`Note-${index}`}
                            className="w-100 p-2 form-control"
                            defaultValue={img.note}
                            onChange={(e) =>
                              setNewBug((prev) => ({
                                ...prev,
                                Note: e.target.value,
                              }))
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="7">
                          <div className="attach-file-container">
                            <div>
                              {bugsimage ? (
                                <>
                                  <img
                                    src={`${AxiosInstance.defaults.baseURL}${img.filepath}`}
                                    alt="attached"
                                    style={{
                                      maxWidth: "300px",
                                      maxHeight: "300px",
                                      cursor: "pointer", // Add pointer cursor to indicate clickability
                                    }}
                                    onClick={() => setShowModal(true)} // Trigger modal on click
                                  />
                                  {showModal && (
                                    <div
                                      className="modal-overlay"
                                      onClick={() => setShowModal(false)} // Close modal on overlay click
                                      style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <div
                                        className="modal-content"
                                        onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking on the image
                                        style={{
                                          position: "relative",
                                          background: "#fff",
                                          padding: "10px",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        <img
                                          src={`${AxiosInstance.defaults.baseURL}${img.filepath}`}
                                          alt="Full size"
                                          style={{
                                            maxWidth: "90vw",
                                            maxHeight: "90vh",
                                          }}
                                        />
                                        <button
                                          onClick={() => setShowModal(false)}
                                          style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            background: "red",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "50%",
                                            width: "30px",
                                            height: "30px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          ✕
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div>
                                  <span>No image found</span>
                                  <div
                                    className="upload-area"
                                    style={{
                                      border: "2px dashed #ccc",
                                      padding: "20px",
                                      width: "100%",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                    onPaste={handlePaste}
                                  >
                                    <h4>Attach Screenshot or File</h4>

                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={handlefile}
                                      id="file-input"
                                    />
                                  </div>
                                </div>
                              )}
                              {/* <img src={bug.filePath}/> */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}

                  
                  {/* Add Note Section */}
                  {/* <tr>
                    <td colSpan="7">
                      <label htmlFor="note" className="fs-5">
                        Add Note
                      </label>
                      <input
                        type="text"
                        name="note"
                        id="note"
                        className="w-100 p-2"
                        value={noteInput}
                        onChange={(e) => setNoteInput(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">
                      <div
                        className="upload-area"
                        style={{
                          border: "2px dashed #ccc",
                          padding: "20px",
                          textAlign: "center",
                        }}
                      >
                        <h4>Attach Screenshot or File</h4>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                        {preview && (
                          <img
                            src={preview}
                            alt="Preview"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "300px",
                              marginTop: "10px",
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="7">
                      <button
                        type="button"
                        // onClick={handleAddNote}
                        className="btn btn-success"
                      >
                        Add Note
                      </button>
                    </td>
                  </tr> */}
                  <tr>
                    <td colSpan="7">
                    {user &&
    (user.permission.includes(2)===true|| user.role===1||user.role===2||user.role===4)&&(
 <button className="btn btn-warning w-100" type="submit">
 Update Bug
</button>
                    )} 
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </form>
        )}
      </div>
      <div className="mt-3">
        <div className="border border-1">
          <div
            className="d-flex bg-info p-2 text-white align-items-center"
            data-bs-toggle="collapse"
            data-bs-target="#collapseBody"
            role="button"
            aria-expanded="false"
            aria-controls="collapseBody"
            // onClick={fetchBugHistory}
          >
            <h5>Bug History</h5>
          </div>
          <div
            id="collapseBody"
            className="collapse overflow-auto"
            style={{
              maxHeight: 300,
            }}
          >
            {BugHistory.length > 0 && (
              <Table
                striped
                bordered
                hover
                responsive
                className=" shadow-sm mt-3"
              >
                <thead className="table-primary ">
                  <tr>
                    <th>Modified Date</th>
                    <th>Modified By</th>
                    <th>Updated Field</th>
                    <th>Bug Name</th>
                    <th>Description</th>
                    <th>Priority</th>
                    <th>Assigned To</th>
                    <th>Due Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {BugHistory.map((data) => {
                    return (
                      <tr key={data.id}>
                        <td>
                          {
                            new Date(data.modifiedDate)
                              .toISOString()
                              .split("T")[0]
                          }
                        </td>
                        <td>{data.modifiedBy}</td>
                        <td>{data.updatedFields}</td>
                        <td>{data.bugName}</td>
                        <td>{data.bugDescription}</td>

                        <td
                          style={{
                            backgroundColor: getPriorityColor(data.priority), // Use newtask.status or fallback to task.status
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {getPriorityName(data.priority)}
                        </td>
                        <td>{data.assignedTo}</td>
                        <td>{data.dueDate}</td>
                        <td
                          style={{
                            backgroundColor: getStatusColor(data.status), // Use newtask.status or fallback to task.status
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          {getStatusName(data.status)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BugDetails;
